import React, { memo, useState, useCallback } from 'react'
import {
  Table, TableBody, TableHead, TableRow, TableCell, Typography,
  Checkbox, Button, TableSortLabel, TextField, TableContainer, Box,
} from '@mui/material'
import { useSelector, useDispatch } from 'react-redux';
import { formSubmitAPI, formObjAdd, formObjDelete, formObjAddMany, formObjDeleteMany, formChange } from '../../reducers/form';
import { addToHistoryW, addToHistoryM } from '../../reducers/history';
import { deleteAndDecreaseEstimate, deleteEstimate, estimatePrint } from '../../api/estimate'
import { editFieldTable } from '../../reducers/formTable';
import { updEstimateMaterialNumber, updEstimateWorkNumber } from '../../api/estimate'
import print from '../../functions/print'
import { fetchDispath } from '../../functions/fetch'
import { makeStyles } from '@mui/styles';
import { blue, green } from '@mui/material/colors';
import { SLUGS } from 'src/enum/permissions.enum';
import { useCan } from 'src/hooks/useCan';
import { tableEstimateHead } from './estimate.const';
import { createSelector } from 'reselect';
import GroupTableDialog from './GroupTableDialog';

function GroupTable({ idProject, loadEstimate, loadGroup, formName }) {
  const [order, setOrder] = useState('asc')
  const [orderBy, setOrderBy] = useState('number')
  const tableGroup = useSelector(state => state.formTable['groupEstimate'] || state.formTable.default)
  const tableResource = useSelector(state => state.formTable['groupResEstimate'] || state.formTable.default)
  const handleRequestSort = (event, property) => {
    let orderNew = 'desc';
    if (orderBy === property && order === 'desc') {
      orderNew = 'asc';
    }
    setOrder(orderNew)
    setOrderBy(property)
  };
  const handleClose = () => {
    setDrawerOpen(false);
    setSelectedItem(null);
  };
  const [selectedItem, setSelectedItem] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const handleRowClick = useCallback((item) => {
    setSelectedItem(item);
    setDrawerOpen(true);
  }, []);
  return (<React.Fragment>
    <TableButtons
      formName={formName}
      loadEstimate={loadEstimate}
      loadGroup={loadGroup}
      orderBy={orderBy}
      order={order}
      idProject={idProject}
    />
    <Box
      sx={{
        display: 'flex',
        border: 1,
        borderColor: 'divider',
        borderRadius: 1,
        overflow: 'hidden', // Чтобы drawer не вылезал за скругления
        minHeight: 200, // Минимальная высота, если таблица пустая
      }}
    >
      <Box sx={{ flex: 1, overflow: 'auto' }}>
        <TableContainer style={{ height: '75vh' }}>
          <Table size='small' stickyHeader >
            <TableHead>
              <TableRow>
                <TableCellSelectAllHeader formName={formName} />
                {tableEstimateHead.map(obj => {
                  const align = obj.align || 'inherit'
                  return (<TableCell
                    key={obj.id}
                    align={align}
                    sortDirection={orderBy === obj.id ? order : false}
                  >
                    <TableSortLabel
                      active={orderBy === obj.id}
                      direction={order}
                      onClick={(e) => handleRequestSort(e, obj.id)}
                    >
                      {obj.name}
                    </TableSortLabel>
                  </TableCell>);
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {tableGroup.allIds.map(id => {
                return <Row
                  key={id}
                  tableResource={tableResource}
                  group={tableGroup.byId[id]}
                  groupId={id}
                  order={order}
                  orderBy={orderBy}
                  idProject={idProject}
                  formName={formName}
                  handleRowClick={handleRowClick}
                />
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
      <Box
        sx={{
          width: drawerOpen ? 400 : 0,
          overflow: 'hidden',
          transition: 'width 0.3s ease',
          borderLeft: drawerOpen ? 1 : 0,
          borderColor: 'divider',
          flexShrink: 0,
        }}
      >
        {drawerOpen && selectedItem && (
          <GroupTableDialog selectedItem={selectedItem} handleClose={handleClose} idProject={idProject} loadGroup={loadGroup} />
        )}
      </Box>
    </Box>

  </React.Fragment>)
}
export default memo(GroupTable)

const selectHasAnySelected = (state, formName) => {
  const selected = state.form[formName]?.values.selectedMainEstimate || {};
  return Object.values(selected).some(value => !!value);
};

function TableButtons({ formName, loadEstimate, loadGroup, orderBy, order, idProject }) {
  const can = useCan()
  const hasSelection = useSelector((state) => selectHasAnySelected(state, formName));
  const dispatch = useDispatch()
  const handleClick = () => {
    dispatch((disp, getState) => {
      const state = getState()
      const selected = state.form[formName]?.values.selectedMainEstimate || {};
      const byId = state.formTable['groupResEstimate'].byId
      const arrMaterial = []
      const arrWork = []
      Object.keys(selected).forEach(id => {
        if (!selected[id]) return;
        const obj = byId[id];
        if (obj.type === 'material') {
          arrMaterial.push(obj.id)
        }
        else {
          arrWork.push(obj.id)
        }
      })
      disp(formSubmitAPI({
        props: {
          material: arrMaterial,
          work: arrWork
        },
        url: deleteEstimate.path({ id: idProject }),
        method: deleteEstimate.type,
        endFunc: (res) => {
          loadEstimate()
          loadGroup()
          disp(formChange({}, { field: 'selectedMainEstimate', name: formName }))
        }
      }, formName))
    })
  }
  const handleDeleteClick = () => {
    dispatch((disp, getState) => {
      const state = getState()
      const selected = state.form[formName]?.values.selectedMainEstimate || {};
      const byId = state.formTable['groupResEstimate'].byId
      const arrMaterial = []
      const arrWork = []
      Object.keys(selected).forEach(id => {
        if (!selected[id]) return;
        const obj = byId[id];
        if (obj.type === 'material') {
          arrMaterial.push(obj.id)
        }
        else {
          arrWork.push(obj.id)
        }
      })
      disp(formSubmitAPI({
        props: {
          material: arrMaterial,
          work: arrWork
        },
        url: deleteAndDecreaseEstimate.path({ id: idProject }),
        method: deleteAndDecreaseEstimate.type,
        endFunc: (res) => {
          loadEstimate()
          loadGroup()
          disp(formChange({}, { field: 'selectedMainEstimate', name: formName }))
        }
      }, formName))
    })
  }
  const handleClickHistory = () => {
    dispatch((disp, getState) => {
      const state = getState()
      const selected = state.form[formName]?.values.selectedMainEstimate || {};
      const byId = state.formTable['groupResEstimate'].byId
      const byIdGroup = state.formTable['groupEstimate'].byId
      const allIdGroup = state.formTable['groupEstimate'].allIds
      const arrMaterial = []
      const arrWork = []
      Object.keys(selected).forEach(id => {
        if (!selected[id]) return;
        const obj = byId[id];
        const gr = allIdGroup.find(key => byIdGroup[key].id === obj.idGroup)
        if (obj.type === 'material') {
          arrMaterial.push({ ...obj, groupName: gr.name })
        }
        else {
          arrWork.push({ ...obj, groupName: gr.name })
        }
      })
      disp(addToHistoryW(arrWork, { idProject }))
      disp(addToHistoryM(arrMaterial, { idProject }))
    })
  }
  const fetch = useCallback((obj) => { return dispatch(fetchDispath(obj)) }, [dispatch])
  const handlePrint = () => {
    print(
      fetch,
      {
        querty: {
          orderBy,
          order
        },
        param: {
          id: idProject
        },
        request: estimatePrint,
      }
    )
  }
  return <>
    {can(SLUGS.PROJECT.ESTIMATE.UPDATE) && <Button disabled={!hasSelection} color="primary" onClick={handleClick}>Удалить из группы</Button>}
    {can(SLUGS.PROJECT.ESTIMATE.UPDATE) && <Button disabled={!hasSelection} color="primary" onClick={handleDeleteClick}>Удалить из насовсем</Button>}
    <Button disabled={!hasSelection} color="primary" onClick={handleClickHistory}>Добавить в историю</Button>
    <Button color="primary" onClick={() => handlePrint()}>Печать</Button>
  </>
}


const makeSelectTableHeadStatus = createSelector(
  [
    (state) => state.formTable['groupResEstimate']?.allIds,
    (state, formName) => state.form[formName]?.values.selectedMainEstimate,
  ],
  (allIds, selectedMap) => {
    if (!allIds?.length) return { isAllSelected: false, isIndeterminate: false };
    const selectedCount = allIds.filter(id => !!selectedMap[id]).length;
    const isAllSelected = selectedCount === allIds.length;
    const isIndeterminate = selectedCount > 0 && selectedCount < allIds.length;
    return { isAllSelected, isIndeterminate };
  }
);
function TableCellSelectAllHeader({ formName }) {
  const dispatch = useDispatch()
  const { isAllSelected, isIndeterminate } = useSelector(state => makeSelectTableHeadStatus(state, formName))
  const handleCheckboxChange = () => {
    if (isAllSelected) {
      dispatch((disp, getState) => {
        const state = getState()
        const allIds = state.formTable['groupResEstimate'].allIds || []
        disp(formObjDeleteMany({ ids: allIds, field: 'selectedMainEstimate', name: formName }))
      })
    }
    else {
      dispatch((disp, getState) => {
        const state = getState()
        const allIds = state.formTable['groupResEstimate'].allIds || []
        let objNew = {}
        allIds.forEach((rowId) => {
          objNew[rowId] = true
        });
        disp(formObjAddMany(objNew, { field: 'selectedMainEstimate', name: formName }))
      })
    }
  }
  return <TableCell padding="checkbox">
    <Checkbox
      checked={isAllSelected}
      indeterminate={isIndeterminate}
      onClick={handleCheckboxChange}
    />
  </TableCell>
}

function desc(a, b) {
  if (b < a) {
    return -1;
  }
  if (b > a) {
    return 1;
  }
  return 0;
}
function stableSort(array, objs, orderBy, order) {
  const stabilizedThis = array.map(key => ([key, objs[key][orderBy]]));
  const ord = order === 'desc' ? 1 : -1
  stabilizedThis.sort((a, b) => {
    return ord * desc(a[1], b[1]);
  });
  return stabilizedThis.map(el => el[0]);
}
const useStyles = makeStyles((theme) => ({
  rowGroup: {
    backgroundColor: 'hsl(0, 0%, 90%)',
    cursor: 'pointer'
  },
  rowDate: {
    "&:hover": { backgroundColor: theme.palette.action.hover }
  },
  cellMaterial: {
    color: green[500]
  },
  cellWork: {
    color: blue[500]
  }
}));
const selectIsIdSelected = (state, id, formName) => !!state.form[formName]?.values.selectedMainEstimate[id];
const selectGroupStatus = (state, rowIds, formName) => {
  const selected = state.form[formName]?.values.selectedMainEstimate || {};
  if (rowIds.length === 0) return { isAllSelected: false, isIndeterminate: false };
  const isAllSelected = rowIds.every(id => !!selected[id]);
  const hasAnySelected = rowIds.some(id => !!selected[id]);
  const isIndeterminate = hasAnySelected && !isAllSelected;
  return { isAllSelected, isIndeterminate };
};
const GroupCheckbox = React.memo(({ id, formName, groupRes }) => {
  const dispatch = useDispatch()
  const status = useSelector((state) => selectGroupStatus(state, groupRes, formName))
  const isSelected = status.isAllSelected
  const isIndeterminate = status.isIndeterminate
  const handleToggle = () => {
    const rowIds = groupRes
    if (isSelected) {
      dispatch(formObjDeleteMany({ ids: rowIds, field: 'selectedMainEstimate', name: formName }))
    }
    else {
      let objNew = {}
      rowIds.forEach((rowId) => {
        objNew[rowId] = true
      });
      dispatch(formObjAddMany(objNew, { field: 'selectedMainEstimate', name: formName }))

    }
  }
  return <TableCell padding="checkbox">
    <Checkbox
      checked={isSelected}
      indeterminate={isIndeterminate}
      onClick={handleToggle}
    />
  </TableCell>
})
const GroupRow = React.memo(({ id, changeShow, formName }) => {
  const classes = useStyles();
  const group = useSelector(state => state.formTable['groupEstimate']?.byId[id])
  return <TableRow className={classes.rowGroup}>
    <GroupCheckbox id={id} formName={formName} groupRes={group.res} />
    <TableCell onClick={changeShow} colSpan={7}>
      <Typography variant='body1'>{group.number + '. ' + group.name}</Typography>
    </TableCell>
    <TableCell colSpan={2} align='right'>
      <Typography variant='body1'>{(Math.round(100 * group.ressumm) / 100).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })}</Typography>
    </TableCell>
  </TableRow>
})

const DataCheckbox = React.memo(({ id, formName }) => {
  const isSelected = useSelector((state) => selectIsIdSelected(state, id, formName));
  const dispatch = useDispatch()
  const handleToggle = () => {
    const metaObj = { id, field: 'selectedMainEstimate', name: formName }
    if (isSelected) {
      dispatch(formObjDelete(metaObj))
    }
    else {
      dispatch(formObjAdd(true, metaObj))
    }
  }
  return <TableCell padding="checkbox">
    <Checkbox
      checked={isSelected}
      onClick={handleToggle}
    />
  </TableCell>
})
const DataRow = React.memo(({ id, idProject, formName, handleRowClick }) => {
  const classes = useStyles();
  const obj = useSelector(state => state.formTable['groupResEstimate']?.byId[id])
  return <TableRow key={id} className={classes.rowDate} >
    <DataCheckbox id={id} formName={formName} />
    {tableEstimateHead.map(e => {
      if (e.id === 'number') return <CellEdited key={e.id} obj={obj} e={e} id={id} idProject={idProject} />
      if (e.id === 'type') {
        if (obj[e.id] === 'material') {
          return <TableCell key={e.id} className={classes.cellMaterial}>М</TableCell>
        }
        return <TableCell key={e.id} className={classes.cellWork}>Р</TableCell>
      }
      return <TableCell key={e.id} align={e.align} onClick={() => handleRowClick(id)}>{obj[e.id]}</TableCell>
    })}
  </TableRow>
})
function Row({ tableResource, group, groupId, order, orderBy, idProject, formName, handleRowClick }) {
  const [show, changeShow] = useState(true)
  const sortedGroupRows = React.useMemo(() => {
    return stableSort(group.res, tableResource.byId, orderBy, order)
  }, [group.res, tableResource.byId, orderBy, order])
  return (
    <React.Fragment>
      <GroupRow
        id={groupId}
        changeShow={() => changeShow(e => !e)}
        formName={formName}
      />
      {
        show && sortedGroupRows
          .map((id, i) => {
            return <DataRow key={id} id={id} idProject={idProject} formName={formName} handleRowClick={handleRowClick} />
          })}
    </React.Fragment>
  );
}


function CellEdited({ obj, e, id, idProject }) {
  const [edit, setEdit] = useState(false)
  const dispatch = useDispatch()
  const [editValue, setEditValue] = useState(obj.number)
  const handleChange = (e) => {
    e.preventDefault();
    setEditValue(Number(e.target.value))
  }
  const handleBlur = () => {
    const url = obj.type === 'material' ? updEstimateMaterialNumber : updEstimateWorkNumber
    setEdit(false)
    const old = obj.number
    if (old === editValue) {
      return;
    }
    dispatch(editFieldTable(editValue, { id, field: 'number', name: 'groupResEstimate' }))
    dispatch(formSubmitAPI({
      props: {
        id: obj.id,
        number: editValue || ''
      },
      url: url.path({ id: idProject }),
      method: url.type,
      endFuncFalse: () => {
        dispatch(editFieldTable(old, { id, field: 'number', name: 'groupResEstimate' }))
      }
    }, 'formName'))
  }
  const handleEdit = () => {
    setEdit(true)
    setEditValue(obj.number)
  }
  return <TableCell
    key={e.id}
    align={e.align}
    onClick={handleEdit}
    sx={{ py: 0.5 }} // Уменьшаем вертикальные отступы ячейки
  >
    {edit ? (
      <TextField
        fullWidth
        variant="standard"
        type="number"
        value={editValue}
        onChange={handleChange}
        onBlur={handleBlur}
        onKeyDown={(e) => {
          if (e.key === 'Enter') handleBlur();   // Сохранить по Enter
          if (e.key === 'Escape') setEdit(false);      // Отмена по Escape
        }}
        autoFocus
        size="small"
        sx={{
          '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button': {
            WebkitAppearance: 'none',
            margin: 0,
          },
        }}
        InputProps={{
          sx: {
            fontSize: '0.875rem',
            textAlign: e.align || 'left',
          },
          inputProps: {
            style: { MozAppearance: 'textfield', padding: '4px 0' }
          }
        }}
        inputProps={{
          style: { MozAppearance: 'textfield' }
        }}
      />
    ) : (
      obj.number
    )}
  </TableCell>
}